import { render, staticRenderFns } from "./orders-table.vue?vue&type=template&id=7a97f3d2&scoped=true"
import script from "./orders-table.vue?vue&type=script&lang=js"
export * from "./orders-table.vue?vue&type=script&lang=js"
import style0 from "./orders-table.vue?vue&type=style&index=0&id=7a97f3d2&prod&lang=scss"
import style1 from "./orders-table.vue?vue&type=style&index=1&id=7a97f3d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a97f3d2",
  null
  
)

export default component.exports